module.exports = __webpack_public_path__ + "img/terminal_icon@3x.f83ba86b.png";